import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { Save as SaveIcon, Cancel as CancelIcon } from "@mui/icons-material";
import { sharedFormStyles } from '@/__core/styles/sharedFormStyles';

interface OrderActionsProps {
  isEditMode: boolean;
  loading: boolean;
  isSubmitting: boolean;
  hasChanges?: boolean;
  disabled?: boolean;
  onCancel: () => void;
  onSave: () => void;
  onUpdate: () => void;
  onResetToNew: () => void;
}

const OrderActions: React.FC<OrderActionsProps> = ({
  isEditMode,
  loading,
  isSubmitting,
  hasChanges = false,
  disabled = false,
  onCancel,
  onSave,
  onUpdate,
}) => {
  const isActionLoading = loading || isSubmitting;

  return (
    <Box sx={sharedFormStyles.actionBar}>
      <Button
        variant="contained"
        size="small"
        startIcon={<CancelIcon />}
        onClick={onCancel}
        disabled={isActionLoading}
        sx={sharedFormStyles.cancelButton}
      >
        Hủy
      </Button>

      {isEditMode ? (
        <Button
          variant="contained"
          size="small"
          startIcon={isActionLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
          onClick={onUpdate}
          disabled={disabled || isActionLoading || !hasChanges}
          sx={sharedFormStyles.primaryButton}
          title={
            disabled
              ? "Bạn không có quyền cập nhật đơn hàng"
              : isActionLoading
              ? "Đang xử lý..."
              : !hasChanges
              ? "Không có thay đổi nào để cập nhật"
              : "Cập nhật đơn hàng"
          }
        >
          Cập nhật
        </Button>
      ) : (
        <Button
          variant="contained"
          size="small"
          startIcon={isActionLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
          onClick={onSave}
          disabled={disabled || isActionLoading || !hasChanges}
          sx={sharedFormStyles.primaryButton}
          title={
            disabled
              ? "Bạn không có quyền tạo đơn hàng"
              : !hasChanges
              ? "Vui lòng nhập ít nhất một trường dữ liệu"
              : ""
          }
        >
          {isActionLoading ? "Đang lưu..." : "Lưu"}
        </Button>
      )}
    </Box>
  );
};

export default OrderActions;
